var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-logos"},[_c('div',{staticClass:"container"},_vm._l((_vm.logos),function(logo){return _c('img',{attrs:{"src":("/footer-logos/" + (logo.file)),"alt":logo.alt,"loading":"lazy"}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }